/* unplugin-vue-components disabled */import script from "./Sidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./Sidebar.vue?vue&type=script&setup=true&lang=ts"

import "./Sidebar.vue?vue&type=style&index=0&id=8c97a218&lang=scss"

const __exports__ = script;

export default __exports__